import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { contact, nav } from "../mock";
import BaseLogo from "./BaseLogo";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = (to) => {
    if (to.startsWith("/#")) {
      const id = to.slice(2);
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(
          () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }),
          200
        );
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(to);
      window.scrollTo({ top: 0 });
    }
  };

  return (
    <footer className="bg-[#0f0f10] text-white">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 py-20">
        <div className="grid md:grid-cols-3 gap-14">
          {/* Brand */}
          <div>
            <BaseLogo size={26} showSub />
            <p className="mt-6 text-[14px] leading-relaxed text-white/50 max-w-xs">
              Principal contractors specialising in one-off and bespoke build
              projects throughout Devon and Cornwall.
            </p>
          </div>

          {/* Nav */}
          <div>
            <p className="text-[11px] tracking-[0.24em] uppercase text-white/40 mb-6">
              Explore
            </p>
            <ul className="space-y-4">
              <li>
                <button
                  onClick={() => handleNav("/")}
                  className="text-[14px] text-white/80 hover:text-white transition-colors"
                >
                  Home
                </button>
              </li>
              {nav.map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => handleNav(item.to)}
                    className="text-[14px] text-white/80 hover:text-white transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <p className="text-[11px] tracking-[0.24em] uppercase text-white/40 mb-6">
              Get in touch
            </p>
            <ul className="space-y-4">
              <li>
                <a
                  href={`mailto:${contact.email}`}
                  className="text-[14px] text-white/80 hover:text-white transition-colors"
                >
                  {contact.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${contact.phoneRaw}`}
                  className="text-[14px] text-white/80 hover:text-white transition-colors"
                >
                  {contact.phone}
                </a>
              </li>
              <li>
                <span className="text-[14px] text-white/60 leading-relaxed block max-w-[240px]">
                  {contact.address}
                </span>
              </li>
            </ul>
            <Link
              to="/contact"
              onClick={() => window.scrollTo({ top: 0 })}
              className="mt-8 inline-flex items-center px-6 py-3 text-[11px] tracking-[0.22em] uppercase text-white transition-all duration-300 hover:brightness-110"
              style={{ backgroundColor: "#E97B2B" }}
            >
              Get in Touch
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-[12px] text-white/35">
          <span>© {new Date().getFullYear()} Base Construction. All rights reserved.</span>
          <span>Devon · Cornwall · United Kingdom</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
